import { tokens } from "@core/theme/tokens";

// Anillo de avance del Gran Premio. Extraído de GrandPrizeConfigScreen.tsx
// (SPEC-208) sin cambiar un solo valor, para que SPEC-209 lo reutilice en el
// detalle del avance y en el modal de validación en vez de copiarlo (plan de
// archivos de la corrida 2026-09-07-spec-209-progress-portal-r3).
export function Ring({
  n,
  goal,
  size = 132,
}: {
  n: number;
  goal: number;
  size?: number;
}) {
  const r = (size - 14) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.min(1, goal > 0 ? n / goal : 0);
  return (
    <div
      style={{ position: "relative", width: size, height: size, flex: "none" }}
    >
      <svg
        width={size}
        height={size}
        style={{ transform: "rotate(-90deg)" }}
        aria-hidden="true"
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="rgba(255,255,255,0.08)"
          strokeWidth={7}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={tokens.gold.light}
          strokeWidth={7}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={c * (1 - pct)}
        />
      </svg>
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <span
          style={{
            font: `600 30px ${tokens.font.display}`,
            color: tokens.gold.light,
            lineHeight: 1,
          }}
        >
          {n}
        </span>
        <span
          style={{
            font: `500 10.5px ${tokens.font.ui}`,
            color: tokens.text.tertiary,
            marginTop: 4,
          }}
        >
          de {goal} autos
        </span>
      </div>
    </div>
  );
}
